import React from "react";
import NavIcon from "./NavIcon";
import logo from "../images/logo/toast-name.png";

const Header = () => {
    return (
        <div className="header" id="home">
            <NavIcon />
            <div className="header-logo">
                <img className="logo" src={logo} alt="toast-logo" />
            </div>
            <span className="location">EAST LONDON, SOUTH AFRICA</span>
        </div>
    );
};

export default Header;
